import { COLORS } from '@/styles/colors';
import { body, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const Link = styled.a`
  ${poppinsMediumFont};
  color: ${COLORS.green[500]};
  text-decoration: none;
  ${body};

  &:hover {
    text-decoration: underline;
  }
`;
